import { render, staticRenderFns } from "./AddEditDeductionRecords.vue?vue&type=template&id=47d684c6&scoped=true"
import script from "./AddEditDeductionRecords.vue?vue&type=script&lang=js"
export * from "./AddEditDeductionRecords.vue?vue&type=script&lang=js"
import style0 from "./AddEditDeductionRecords.vue?vue&type=style&index=0&id=47d684c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d684c6",
  null
  
)

export default component.exports